import React, { useState } from "react";
import styled from "styled-components";
import { AngleDoubleLeft } from "@styled-icons/fa-solid/AngleDoubleLeft";
import { AngleDoubleRight } from "@styled-icons/fa-solid/AngleDoubleRight";
import { AngleLeft } from "@styled-icons/fa-solid/AngleLeft";
import { AngleRight } from "@styled-icons/fa-solid/AngleRight";

export const PageNavButton = styled.button`
  background-color: #f7fafd;
  border: 1px solid white;
  border-radius: 5px;
  color: #7fa1c8;
  height: 34px;
  width: 34px;
  padding: 0;

  &:hover:enabled {
    color: #7fa1c8;
    background-color: #e4f0fb;
  }

  &:disabled {
    background-color: #f7f7f7;
    cursor: not-allowed;
    color: lightgray;
  }
`;

export const PageInput = styled.input`
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 5px 7px;
  font-size: inherit;
  border-radius: 3px;
  font-weight: normal;
  outline: none;
  width: 60px;
  text-align: center;
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 20px;
  ${(props) =>
    props.paginationDisable &&
    `
      display: none;
  `};

  // Pagination design for expanded subrow
  ${PageNavButton} {
    ${(props) =>
      props.isExpandedRow &&
      `
    padding: 4px;
    color: #0071BC;
    background-color: transparent;
    border: none;
    &:hover:enabled {
      background-color: rgba(0, 113, 189, 0.1);
    }
    &:disabled {
      color: #a0b2bd;
      background-color: transparent;
    }
    border-radius: 100px;
    `};
  }
  select,
  ${PageInput} {
    ${(props) =>
      props.isExpandedRow &&
      `
    border-radius: 8px;
    `};
  }

  .input-page {
    margin: 0 2rem;
  }

  select {
    margin-left: 1rem;
  }
`;

export const PaginationComponent = ({
  pageIndex = 0,
  pageOptions = [],
  pageCount = 0,
  pageSize = 10,
  setPageSize = () => {},
  pageSizeOptions = [10, 25, 50],
  previousPage = 0,
  nextPage = 0,
  canPreviousPage = false,
  canNextPage = false,
  gotoPage = () => {},
  isExpandedRow,
}) => {
  const [pageValue, setPageValue] = useState(0);
  const goToFirstPage = () => {
    setPageValue(0);
    gotoPage(0);
  };
  const totalPageCount = pageOptions?.length || pageCount;

  return (
    <Pagination isExpandedRow={isExpandedRow}>
      <PageNavButton
        type="button"
        onClick={() => {
          gotoPage(0);
        }}
        title="First Page"
        disabled={!canPreviousPage}
      >
        <AngleDoubleLeft size="1rem" />
      </PageNavButton>{" "}
      <PageNavButton
        type="button"
        onClick={() => previousPage()}
        title="Previous Page"
        disabled={!canPreviousPage}
      >
        <AngleLeft size="1rem" />
      </PageNavButton>{" "}
      <div className="input-page">
        <label htmlFor="Pagination">Page </label>
        <span>
          <PageInput
            className="pagination-container"
            type="number"
            title="Page Number"
            value={pageValue === "" ? "" : pageIndex + 1}
            onChange={(e) => {
              let page;
              if (e.target.value > totalPageCount) {
                page = totalPageCount;
              } else {
                page = e.target.value;
              }
              if (page === "") {
                goToFirstPage();
              }
              setPageValue(page);
              gotoPage(Number(page) - 1);
            }}
            onBlur={() => {
              if (pageValue === "") {
                goToFirstPage();
              }
            }}
          />
        </span>{" "}
        of <span className="totalPages">{totalPageCount}</span>
      </div>
      <PageNavButton
        type="button"
        onClick={() => nextPage()}
        title="Next Page"
        disabled={!canNextPage}
      >
        <AngleRight size="1rem" />
      </PageNavButton>{" "}
      <PageNavButton
        type="button"
        onClick={() => gotoPage(totalPageCount - 1)}
        title="Last Page"
        disabled={!canNextPage}
      >
        <AngleDoubleRight size="1rem" />
      </PageNavButton>{" "}
      {!!pageSizeOptions && (
        <select
          value={pageSize}
          title="Page Size"
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            gotoPage(0);
          }}
        >
          {pageSizeOptions.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      )}
    </Pagination>
  );
};
